import { render, staticRenderFns } from "./AcknowledageTab.vue?vue&type=template&id=9055b47c&scoped=true"
import script from "./AcknowledageTab.vue?vue&type=script&lang=js"
export * from "./AcknowledageTab.vue?vue&type=script&lang=js"
import style0 from "./AcknowledageTab.vue?vue&type=style&index=0&id=9055b47c&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9055b47c",
  null
  
)

export default component.exports